module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-bg-2-sp-160f6357df334c092c07c45d8d1c0bf6.png";